import type { Root } from 'mdast';
import { visit } from 'unist-util-visit';

/**
 * Remark plugin: принудительно делает все списки «плотными» (tight),
 * убирая обёртки <p> внутри <li> и лишние отступы.
 */
export function remarkTightList() {
  return (tree: Root) => {
    visit(tree, (node) => {
      if (node.type === 'list') {
        (node as { spread?: boolean }).spread = false;
      }
      if (node.type === 'listItem') {
        (node as { spread?: boolean }).spread = false;
      }
    });
  };
}
